import { useNavigate } from "react-router-dom";
import { databaseKey } from "../common/database_key";
import { fetchData, updateData } from "../firebase/firebase_methods";

export const useUpdatePaymentStatus = () => {
  const navigate = useNavigate();

  const updatePaymentStatus = async (selectedPlan) => {
    try {
      const collectionName = databaseKey();
      const paymentId = localStorage.getItem("paymentId");

      if (!paymentId) {
        console.error("Payment ID is missing.");
        return;
      }

      const bannerRef = fetchData(`${collectionName}/banner/${paymentId}`);
      await updateData(bannerRef, {
        paymentStatus: "success",
      });

      const amount = selectedPlan.amount;
      const expiry = selectedPlan.expiry;

      await updateData(bannerRef, {
        amount: amount,
        expiry: expiry,
      });

      localStorage.removeItem("paymentId");

      navigate("/practice");
    } catch (error) {
      console.error("Error updating payment status:", error);
    }
  };

  return updatePaymentStatus;
};
